"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewConsumer = exports.ViewProvider = void 0;
var react_1 = __importDefault(require("react"));
var ViewContext = react_1.default.createContext({});
exports.ViewProvider = ViewContext.Provider;
exports.ViewConsumer = ViewContext.Consumer;
exports.default = ViewContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb250ZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdEQUEwQjtBQUcxQixJQUFNLFdBQVcsR0FBRyxlQUFLLENBQUMsYUFBYSxDQUFDLEVBQW1CLENBQUMsQ0FBQztBQUVoRCxRQUFBLFlBQVksR0FBRyxXQUFXLENBQUMsUUFBUSxDQUFDO0FBQ3BDLFFBQUEsWUFBWSxHQUFHLFdBQVcsQ0FBQyxRQUFRLENBQUM7QUFDakQsa0JBQWUsV0FBVyxDQUFDIn0=